import { render } from "./DMSEditCustomerDetail.vue?vue&type=template&id=85cb70d2"
import script from "./DMSEditCustomerDetail.vue?vue&type=script&lang=js"
export * from "./DMSEditCustomerDetail.vue?vue&type=script&lang=js"

import "./DMSEditCustomerDetail.vue?vue&type=style&index=0&id=85cb70d2&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__